import { resizeObservers as r } from "./highrise1820.mjs";
import { calculateDepthForNode as i } from "./highrise1848.mjs";
var n = function(t) {
  r.forEach(function(e) {
    e.activeTargets.splice(0, e.activeTargets.length), e.skippedTargets.splice(0, e.skippedTargets.length), e.observationTargets.forEach(function(s) {
      s.isActive() && (i(s.target) > t ? e.activeTargets.push(s) : e.skippedTargets.push(s));
    });
  });
};
export {
  n as gatherActiveObservationsAtDepth
};
